<template>
  <el-dialog
    title="审批详情"
    :visible.sync="visible"
    width="30%"
    :before-close="closePup"
    >
      <template v-if="isInDingTalk">
        <el-timeline>
          <el-card style="margin-bottom:20px">
          <h4>申请人：&nbsp;&nbsp;
            {{approvalInof.createUser}}
            <el-tag size="small" type="warning">{{approvalInof.nodes && approvalInof.nodes.length > 1 ? '顺序审批' : '会审'}}</el-tag>
          </h4>
          <p>发起时间：&nbsp;&nbsp;<span>{{approvalInof.taskCreateTime}}</span></p>
        </el-card>
          <template v-for="(item,i) of approvalInof.nodes">
            <template v-for="task of item.taskList">
              <el-timeline-item  :key="i+'_'+task.userId"
                :color="compuColor(task)"
              >
                <el-card>
                  <h4>{{task.name}}</h4>
                  <div class="info-box">
                    <p>
                      <el-tag
                        size="small"
                        :type="comstatus(task) === 1 ? 'success' : (comstatus(task) === 2 ? 'danger' : 'warning')"
                      >{{comstatus(task) === 1 ? '已同意' : (comstatus(task) === 2 ? '已驳回' : '审批中')}}</el-tag>
                      &nbsp;&nbsp;<span>{{task.finishTime}}</span>
                    </p>
                    <el-button
                      v-if="comstatus(task) === 0"
                      plain size="mini"
                      type="primary"
                      :disabled="order(i,approvalInof.nodes)"
                      @click="urgentReview(task)"
                    >催审</el-button>
                  </div>
                </el-card>
              </el-timeline-item>
            </template>
          </template>
        </el-timeline>
      </template>
      <template v-if="!isInDingTalk">
        <!-- 申请人 -->
        <el-card style="margin-bottom:20px">
          <h4>申请人：&nbsp;&nbsp;
            {{approName()}}
              <!-- <el-tag size="small" type="warning">{{approvalInof.nodes && approvalInof.nodes.length > 1 ? '顺序审批' : '会审'}}</el-tag> -->
          </h4>
          <p>发起时间：&nbsp;&nbsp;<span>{{approvalInof.approRowInfo&&approvalInof.approRowInfo.createTime}}</span>&nbsp;&nbsp;
          </p>
        </el-card>
        <el-timeline>
          <template v-for=" (item,i) of approvalInof.instPartyList">
            <el-timeline-item :key="i"
              :color="item.flowStatus === 1 ? '#67C23A' : (item.flowStatus ? '#F56C6C' : '#E6A23C')"
            >
              <el-card>
                <h4>{{item.userName}}</h4>
                <div class="info-box">
                  <p>
                    <el-tag
                      size="small"
                      :type="item.flowStatus === 1 ? 'success' : (item.flowStatus === 2 ? 'danger' : 'warning')"
                    >{{item.flowStatus === 1 ? '已同意' : (item.flowStatus === 2 ? '已拒绝' : '审批中')}}</el-tag>
                    &nbsp;&nbsp;<span>{{item.flowTime}}</span>
                  </p>
                  <el-button
                    v-if="($route.query.signStatus == 5 || $route.query.signStatus == 6) && item.flowStatus === 0"
                    plain
                    size="mini"
                    type="primary"
                    :disabled="approvalInof.orderNum && i > 0 && approvalInof.instPartyList[i-1].flowStatus !== 1"
                    @click="sendApproveSealSms(item)"
                  >催审</el-button>
                </div>
                <div class="approve_reason" v-if="[1,2].includes(item.flowStatus) && item.refuseReason">
                  <p style="font-weight: bold">审批意见：</p>
                  <span>{{item.refuseReason}}</span>
                </div>
              </el-card>
            </el-timeline-item>
          </template>
        </el-timeline>
      </template>
  </el-dialog>
</template>
<script>
import { isInDingTalk } from "@/assets/js/utils/ding-env";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";
import {ApiCorpMethods} from "@/assets/js/http-serve/corp/http-methods";
  export default {
    props:{
      proceVisi: {
        type: Boolean,
        default: false
      },
      approvalInof:{
        type:Object,
        default:{
          nodes:[],
          instPartyList:[],
          approRowInfo:{
            ebqUserName:'',
            signatoryName:'',
            createTime:''
          }
        }
      }
    },
    data () {
      // 这里存放数据
      return {
        isInDingTalk,
        visible:false
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {
      proceVisi(val){
        this.visible=val
      },
    },
    // 方法集合
    methods: {
      /** 申请人名称 */
      approName(){
        const name = this.approvalInof.approRowInfo && this.approvalInof.approRowInfo.ebqUserName
              ? this.approvalInof.approRowInfo.ebqUserName
              : (this.approvalInof.approRowInfo && this.approvalInof.approRowInfo.signatoryName ? this.approvalInof.approRowInfo.signatoryName : '')
        const _names = name ? name.split('-') : []
        return _names.length > 1 ? _names[1] : ''
      },
      /** 顺序审催审判断 */
      order(i,nodes){
        const orderLen = nodes.length > 1;
        if(orderLen){
          // 顺序审
          const prve = nodes[i-1]
          // !==1 上个节点不是同意状态就禁用当前节点的催审
          return prve && this.comstatus(prve.taskList[0]) !== 1 ? true : false
        }else{
          return false
        }
      },
      /** 催审 */
      urgentReview(user){
        const {dingTalkCorpId:corpId,dingTalkUserId} = JSON.parse(sessionStorage.getItem("dingloginInfo")),
          {approRowInfo:row,procInstId}=this.approvalInof,
          _this = this;
        const param = {
          corpId,
          dingTalkUserId,
          procInstId,
          applyNo:row.applyNo,
          remindUserId:user.userId,
          // remindType 催审类型，1：合同，2：用印
          remindType: row.approRowFlowType,
          objectName: row.approRowFlowType == 1 ? row.applyName : row.contractName,
        }
        dingtalkApi.remindAudit(param).then(res=>{
          if(!res.success) return _this.$message.error(res.description)
          _this.$message.success(res.description)
        })
      },
      /** 用印审批催审 */
      sendApproveSealSms (item) {
        const {signNo}= this.approvalInof;
        if(!this.approvalInof.flowType) return this.sendFileSms(item)
          ApiCorpMethods.CorpSealSignInfoController.flowApprovesealSms({
            signNo,
            partyIdNo: item.partyIdNo
          }).then(res => {
            if (!res.success)
              return this.$message.error(res.description || this.$tip);
            this.$message.success("成功发送提醒通知");
          });
      },
      /** 文件审批催审 */
      sendFileSms(item){
        const {approRowInfo}=this.approvalInof
        const param ={
          applyNo:approRowInfo.applyNo,
          partyIdNo: item.partyIdNo
        }
        ApiCorpMethods.SendSms4SignController.reminderApprova(param)
        .then(res => {
          let data = res.data;
          if (res.success || res.success === "true") {
            if (res.data.recharge) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            } else {
              this.$confirm(
                `<div style="font-weight: bold;color: #606266;font-size: 18px;text-align: center;border: 1px dashed #FCE2E2;padding-bottom: 5px ">
                            <img src="/images/icon_signed.png" style="height: 80px">
                            <p style="margin-top: 10px">需花费：
                            <span style="color: #Ec1C1C">${data.point}积分/次</span></p>
                            <p style="margin-top: 10px;padding: 0 10px;font-weight: 400;font-size: 14px;text-align: start">
                            <i class="el-icon-info" style="margin-right: 5px"></i>
                            确定后，待审批的审批方将收到审批短信通知，该通知72小时有效</p></div>`,
                "温馨提示",
                {
                  showConfirmButton: true,
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                  customClass: "handle-message"
                  // type: 'info',
                }
              ).then(() => {
                ApiCorpMethods.SendSms4SignController.reminderApprova(
                  Object.assign(param, { pay: 1 })
                ).then(res => {
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  if (+res.code === 0) {
                    this.$emit("resetList");
                    return this.$message.success("催审成功");
                  }
                  this.$message.error(res.description || "支付失败");
                });
              });
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          this.$message.error(err.description || "数据初始化失败");
        });
      },
      /** 处理审批状态 */
      comstatus(obj){
        return obj.result === 'AGREE' ? 1 : obj.result === 'REFUSE' ? 2 : 0
      },
      compuColor(obj){
        return this.comstatus(obj) === 1 ? '#67C23A' : this.comstatus(obj)===2 ? '#F56C6C' : '#E6A23C'
      },
      closePup(){
        this.$emit('close')
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>

<style lang='less' scoped>
  // @import url(); 引入公共css类
  .info-box{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .approve_reason {
    margin: 5px;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close{
    color:#909399 !important;
  }
</style>



// WEBPACK FOOTER //
// pages/corp/signInfo/components/approvalInfoPup.vue